import { render, staticRenderFns } from "./application.vue?vue&type=template&id=1270cf0f&"
import script from "./application.ts?vue&type=script&lang=js&"
export * from "./application.ts?vue&type=script&lang=js&"
import style0 from "./../../css/main.scss?vue&type=style&index=0&rel=prelaod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports